export default function config(state = {}) {
  return state;
}
